import { getAllProposals, getProposal, getProposalsStatistics } from 'repositories/proposal.repository';
import { Instruction, MetAmorc } from 'src/constants/dropdown-values';

export const RECEIVED_PROPOSALS = '[Admin] RECEIVED_PROPOSALS';
const receivedProposals = (payload) => ({
  type: RECEIVED_PROPOSALS,
  payload,
});

export const FETCH_PROPOSALS = '[Admin] FETCH_PROPOSALS';
export const fetchProposals = (page, perPage, where) => async (dispatch) => {
  dispatch({ type: FETCH_PROPOSALS });
  return getAllProposals(page, perPage, where)
    .then((response) => response.data)
    .then((data) => dispatch(receivedProposals(data)));
};

export const RECEIVED_PROPOSAL = '[Admin] RECEIVED_PROPOSAL';
export const receivedProposal = (payload) => ({
  type: RECEIVED_PROPOSAL,
  payload,
});

export const FETCH_PROPOSAL = '[Admin] FETCH_PROPOSAL';
export const fetchProposal = (uuid) => (dispatch) => {
  dispatch({ type: FETCH_PROPOSAL });
  getProposal(uuid)
    .then((response) => response.data)
    .then((data) => dispatch(receivedProposal(data)));
};

export const RECEIVED_PROPOSALS_STATISTICS = '[Admin] RECEIVED_PROPOSALS_STATISTICS';
export const receivedProposalsStatistics = (payload) => ({
  type: RECEIVED_PROPOSALS_STATISTICS,
  payload,
});

export const FETCH_PROPOSALS_STATISTICS = '[Admin] FETCH_PROPOSALS_STATISTICS';
export const fetchProposalsStatistics = () => (dispatch) => {
  getProposalsStatistics()
    .then((response) => response.data)
    .then((response) => {
      const data = response;
      const instructionValues = (() => {
        const obj = {};
        for (let i = 0; i < Instruction.length; i += 1) {
          obj[Instruction[i].value] = Instruction[i].label;
        }
        return obj;
      })();

      const metAmorcValues = (() => {
        const obj = {};
        for (let i = 0; i < MetAmorc.length; i += 1) {
          obj[MetAmorc[i].value] = MetAmorc[i].label;
        }
        return obj;
      })();
      data.groupedByMetAmorc = (() => {
        const objects = [];
        data.groupedByMetAmorc.forEach((el) => {
          if (el.conheceu && metAmorcValues[el.conheceu]) {
            objects.push({
              name: metAmorcValues[el.conheceu],
              value: el.value,
            });
          }
        });
        return objects;
      })();
      data.groupedByEducation = (() => {
        const objects = [];
        data.groupedByEducation.forEach((el) => {
          if (el.instrucao && instructionValues[el.instrucao]) {
            objects.push({
              name: instructionValues[el.instrucao],
              value: el.value,
            });
          }
        });
        return objects;
      })();

      data.groupedByGender = data.groupedByGender.map((element) => {
        const el = element;
        if (el.sexo === 'F') {
          el.name = 'Feminino';
        } else {
          el.name = 'Masculino';
        }

        return el;
      });
      const stateMap = {
        AC: '001',
        AL: '002',
        AP: '003',
        AM: '004',
        BA: '005',
        CE: '006',
        DF: '007',
        ES: '008',
        GO: '009',
        MA: '010',
        MT: '011',
        MS: '012',
        MG: '013',
        PA: '014',
        PB: '015',
        PR: '016',
        PE: '017',
        PI: '018',
        RJ: '019',
        RN: '020',
        RS: '021',
        RO: '022',
        RR: '023',
        SC: '024',
        SP: '025',
        SE: '026',
        TO: '027',
      };
      data.groupedByState = (() => {
        const objects = [];
        data.groupedByState.forEach((el) => {
          if (el.state && stateMap[el.state]) {
            objects.push({
              id: stateMap[el.state],
              value: el.value,
              showLabel: '1',
            });
          }
        });
        return objects;
      })();

      dispatch(receivedProposalsStatistics(data));
    });
};
